var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close-container",on:{"click":_vm.clickOnClose}},[_c('img',{staticClass:"close-container__btn",attrs:{"alt":"close-button","src":require('@/assets/img/close-button.svg')}})])}
var staticRenderFns = []

export { render, staticRenderFns }